export function transformRegistrationPlatePaste(e: React.ClipboardEvent<HTMLInputElement>) {
  const input = e.currentTarget;
  const clipboardText = e.clipboardData.getData('text');

  const filteredText = clipboardText
    .split('')
    .filter((char) => /^[A-Z0-9]$/i.test(char))
    .join('')
    .toUpperCase();

  if (filteredText.length === 0) {
    e.preventDefault();
    return;
  }

  input.setRangeText(filteredText, input.selectionStart ?? 0, input.selectionEnd ?? 0, 'end');

  input.dispatchEvent(new Event('input', {bubbles: true}));
  e.preventDefault();
}
